export default __webpack_public_path__ + "static/media/2d.8b40f923.png";